export default "__VITE_ASSET__DKH0Luhq__"